import { concat as _concat } from 'lodash';
import { RegisterUserDataModel } from './user-data.model';
import { countriesSelectArray } from '../../Locals/locals-countries.data';
import { EditUserDataModel } from './user-data.model';

import { formatMessage } from 'src/api';
import MESSAGES from './../../../../app/Pages/Register/Register.messages';

export const registerUserDataForm = (): RegisterUserDataModel => {
  const countries = countriesSelectArray();
  return {
    gender: {
      col: 12,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserGenderError}),
      name: 'gender',
      label: formatMessage({...MESSAGES.registerUserGender}),
      type: 'radio',
      required: true,
      validation: undefined,
      value: 0,
      options: [{
        disabled: false,
        label: formatMessage({...MESSAGES.registerUserGenderMr}),
        selected: false,
        value: 1,
      }, {
        disabled: false,
        label: formatMessage({...MESSAGES.registerUserGenderMrs}),
        selected: false,
        value: 2,
      }],
    },
    firstName: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserFirstNameError}),
      label: formatMessage({...MESSAGES.registerUserFirstName}),
      name: 'firstName',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserFirstName}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    lastName: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserLastNameError}),
      label: formatMessage({...MESSAGES.registerUserLastName}),
      name: 'lastName',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserLastName}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    phone: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.registerUserPhone}),
      name: 'phone',
      type: 'tel',
      placeholder: formatMessage({...MESSAGES.registerUserPhone}),
      required: false,
      validation: 'isMobilePhone',
      value: '',
    },
    mobile: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.registerUserMobile}),
      name: 'mobile',
      type: 'tel',
      placeholder: formatMessage({...MESSAGES.registerUserMobile}),
      required: false,
      validation: 'isMobilePhone',
      value: '',
    },
    company: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.registerUserCompany}),
      name: 'company',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserCompany}),
      required: false,
      validation: 'isLength',
      value: '',
    },
    addressAdditional: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.registerUserAddressAdditional}),
      name: 'addressAdditional',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserAddressAdditional}),
      required: false,
      value: '',
    },
    street: {
      col: 4,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserStreetError}),
      label: formatMessage({...MESSAGES.registerUserStreet}),
      name: 'street',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserStreet}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    houseNumber: {
      col: 2,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserHouseError}),
      label: formatMessage({...MESSAGES.registerUserHouse}),
      name: 'houseNumber',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserHouse}),
      required: true,
      value: '',
    },
    zip: {
      col: 2,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserZipError}),
      label: formatMessage({...MESSAGES.registerUserZip}),
      name: 'zip',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserZip}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    city: {
      col: 4,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserCityError}),
      label: formatMessage({...MESSAGES.registerUserCity}),
      name: 'city',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserCity}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    country: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserCountryError}),
      label: formatMessage({...MESSAGES.registerUserCountry}),
      name: 'country',
      type: 'select',
      placeholder: formatMessage({...MESSAGES.registerUserCountry}),
      required: true,
      validation: '',
      value: '',
      multiple: false,
      options: _concat(
        [], 
        [{
          label: formatMessage({...MESSAGES.registerUserCountryLabel}),
          value: '',
          disabled: true,
        }], 
        countries
      )
    },
    accountNumber: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.registerUserClientNr}),
      name: 'accountNumber',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserClientNr}),
      required: false,
      validation: 'isLength',
      value: '',
    },
    branch: {
      col: 12,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.registerUserBranchError}),
      name: 'branch',
      label: formatMessage({...MESSAGES.registerUserBranch}),
      type: 'radio',
      required: true,
      validation: undefined,
      value: 0,
      options: [{
        disabled: false,
        label: formatMessage({...MESSAGES.registerUserSanitary}),
        selected: false,
        value: 1,
      }, {
        disabled: false,
        label: formatMessage({...MESSAGES.registerUserPlanner}),
        selected: false,
        value: 2,
      }, {
        disabled: false,
        label: formatMessage({...MESSAGES.registerUserPlumber}),
        selected: false,
        value: 3,
      }, {
        disabled: false,
        label: formatMessage({...MESSAGES.registerUserRetail}),
        selected: false,
        value: 4,
      }],
    }
  };
};


export const editUserDataForm = (): EditUserDataModel => {
  const countries = countriesSelectArray();
  return {
    gender: {
      col: 12,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserGenderError}),
      name: 'gender',
      label: formatMessage({...MESSAGES.editUserGender}),
      type: 'radio',
      required: true,
      validation: undefined,
      value: 0,
      options: [{
        disabled: false,
        label: formatMessage({...MESSAGES.editUserGenderMr}),
        selected: false,
        value: 1,
      }, {
        disabled: false,
        label: formatMessage({...MESSAGES.editUserGenderMrs}),
        selected: false,
        value: 2,
      }],
    },
    firstName: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserFirstNameError}),
      label: formatMessage({...MESSAGES.editUserFirstName}),
      name: 'firstName',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserFirstName}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    lastName: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserLastNameError}),
      label: formatMessage({...MESSAGES.editUserLastName}),
      name: 'lastName',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserLastName}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    phone: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.editUserPhone}),
      name: 'phone',
      type: 'tel',
      placeholder: formatMessage({...MESSAGES.editUserPhone}),
      required: false,
      validation: 'isMobilePhone',
      value: '',
    },
    mobile: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.editUserMobile}),
      name: 'mobile',
      type: 'tel',
      placeholder: formatMessage({...MESSAGES.editUserMobile}),
      required: false,
      validation: 'isMobilePhone',
      value: '',
    },
    company: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.registerUserCompany}),
      name: 'company',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.registerUserCompany}),
      required: false,
      validation: 'isLength',
      value: '',
    },
    addressAdditional: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: undefined,
      label: formatMessage({...MESSAGES.editUserAddressAdditional}),
      name: 'addressAdditional',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserAddressAdditional}),
      required: false,
      value: '',
    },
    street: {
      col: 4,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserStreetError}),
      label: formatMessage({...MESSAGES.editUserStreet}),
      name: 'street',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserStreet}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    houseNumber: {
      col: 2,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserHouseError}),
      label: formatMessage({...MESSAGES.editUserHouse}),
      name: 'houseNumber',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserHouse}),
      required: true,
      minLength: 1,
      value: '',
    },
    zip: {
      col: 2,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserZipError}),
      label: formatMessage({...MESSAGES.editUserZip}),
      name: 'zip',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserZip}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    city: {
      col: 4,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserCityError}),
      label: formatMessage({...MESSAGES.editUserCity}),
      name: 'city',
      type: 'text',
      placeholder: formatMessage({...MESSAGES.editUserCity}),
      required: true,
      validation: 'isLength',
      value: '',
    },
    country: {
      col: 6,
      defaultValue: undefined,
      disabled: false,
      error: false,
      errorMessage: formatMessage({...MESSAGES.editUserCountryError}),
      label: formatMessage({...MESSAGES.editUserCountry}),
      name: 'country',
      type: 'select',
      placeholder: formatMessage({...MESSAGES.editUserCountry}),
      required: true,
      validation: '',
      value: '',
      multiple: false,
      options: _concat(
        [], 
        [{
          label: formatMessage({...MESSAGES.editUserCountryLabel}),
          value: '',
          disabled: true,
        }], 
        countries
      )
    }
  };
};

